/**
 * Session expiry (spec §2: warn before the session expires). The token's
 * `exp` decides; the warning comes two minutes before it.
 */

export const WARNING_LEAD_MS = 2 * 60 * 1000;

/** setTimeout keeps delays in a signed 32-bit int. */
const MAX_DELAY = 2 ** 31 - 1;

export interface ExpiryPlan {
  /** ms until the warning (0 = now), or null when there is no expiry. */
  warnIn: number | null;
  /** ms until the token expires (0 = already expired), or null. */
  expireIn: number | null;
}

export const planExpiry = (
  expiresAt: number | null,
  now: number,
  lead = WARNING_LEAD_MS,
): ExpiryPlan => {
  if (expiresAt == null || !Number.isFinite(expiresAt)) {
    return { warnIn: null, expireIn: null };
  }
  const expireIn = Math.max(0, expiresAt - now);
  const warnIn = Math.max(0, expiresAt - lead - now);
  return {
    warnIn: Math.min(warnIn, MAX_DELAY),
    expireIn: Math.min(expireIn, MAX_DELAY),
  };
};

/** Whole minutes left, at least 1 while not expired, for the warning text. */
export const minutesLeft = (expiresAt: number, now: number): number =>
  Math.max(1, Math.ceil((expiresAt - now) / 60_000));
